import { ArsenalBack } from '@components/arsenal/ArsenalBack';
import { useTranslation } from 'react-i18next';
import * as Shared from '@shared/lib';

interface ItemInfoProps {
  item: string;
  onBack?: () => void;
}

export function ItemInfo({ item, onBack }: ItemInfoProps) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Items' });

  const data = Shared.itemData.find((c) => c.key === item);
  if (!data) return null;

  return (
    <>
      {onBack && (
        <ArsenalBack bg="inventory.avif" onClick={onBack} />
      )}

      <div className="h-48 border-b border-secondary p-4 relative flex justify-center">
        <div className="absolute inset-0 grid-overlay" />
        <div className="absolute inset-0 bg-black/40" />
        <img className="max-w-[100%] max-h-[100%] my-auto blur-animation"
          src={`/assets/items/${item}.avif`}
          alt={item}
        />
      </div>

      <div className="p-2 text-left">
        <p className="text-lg font-bold leading-tight text-gold">{t(item)}</p>
        <p className="text-gray-300 text-xs mt-2 italic">{t(`${item}Info`)}</p>
      </div>
    </>
  );

}